module.exports = __webpack_public_path__ + "img/05物流领域.24a9b24f.jpg";